// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh1[data-v-1c1413fa] {\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--1c1413fa-size);\n  line-height: 29px;\n  line-height: 1.2;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
